import { Work, formatIsbdTitle } from "@biblioteksentralen/cordata";
import { HStack, Heading, Text, VStack } from "@biblioteksentralen/react";
import { DocumentTypes } from "../DocumentTypes";
import { ItemCoverImage } from "../ItemCoverImage";
import { getDotseparated } from "../getDotseparated";
import { ReservableHolding } from "./useChosenReservableHolding";
import { CordataWork, formatLanguagesList } from "@libry-content/integrations";

type ReservationModalWorkPreviewProps = {
  work: Work;
  reservableHolding: ReservableHolding;
  hideImage?: boolean;
};

export const ReservationModalWorkPreview = ({
  work,
  hideImage,
  reservableHolding: { manifestation },
}: ReservationModalWorkPreviewProps) => {
  const languagesAndYear = [
    formatLanguagesList(manifestation.expression.languages, { capitalizeFirstLetter: true }),
    manifestation.publicationYear,
  ];

  return (
    <HStack as="section" spacing="1rem">
      <ItemCoverImage item={new CordataWork(work, manifestation.id)} usePlaceholder={hideImage} maxWidth="7rem" />
      <VStack alignItems="flex-start" spacing="0.75rem">
        {!!manifestation.documentType && <DocumentTypes documentTypes={[manifestation.documentType]} lineHeight="1" />}
        <Heading as="h2" fontSize="lg">
          {formatIsbdTitle(manifestation)}
        </Heading>
        <Text fontSize="sm">{getDotseparated(languagesAndYear)}</Text>
      </VStack>
    </HStack>
  );
};
